import(/* webpackMode: "eager", webpackExports: ["MainContainer"] */ "/opt/build/repo/app/_components/layout/Main/style.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/site/Footer/index.tsx");
